// src/pages/Homepage.jsx
import React, { useState, useEffect } from "react";
import { useLocale } from "../contexts/LocaleContext";
import { getHomepageData } from "../api/apiService";

import BannerSwiper from "../components/homepage/BannerSwiper";
import FeaturedProducts from "../components/homepage/FeaturedProducts";
import SolutionsSection from "../components/homepage/SolutionsSection";
import PartnersSection from "../components/homepage/PartnersSection";

function HomePage() {
  const { locale } = useLocale();
  const [homepageData, setHomepageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomepageContent = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getHomepageData(locale);
        setHomepageData(data);
      } catch (err) {
        setError(err.message || "Failed to load content.");
        setHomepageData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchHomepageContent();
  }, [locale]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100vh-200px)]">
        <p className="text-xl text-gray-500">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-red-500 text-xl">Error: {error}</p>
      </div>
    );
  }

  if (!homepageData) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-gray-700 text-xl">
          No content available for this page.
        </p>
      </div>
    );
  }

  const {
    banner,
    featured_products_title,
    featured_products_list,
    solutions_title,
    solutions_list,
    partners,
  } = homepageData;

  return (
    <div className="bg-white">
      <BannerSwiper banners={banner} />

      <FeaturedProducts
        title={featured_products_title}
        products={featured_products_list}
      />

      <SolutionsSection title={solutions_title} solutions={solutions_list} />

      <PartnersSection partners={partners} />
    </div>
  );
}

export default HomePage;
